import { Component, OnInit } from '@angular/core';

@Component({
    standalone: false,
    selector: 'particle-data-survey-field-selector',
  templateUrl: './data-survey-field-selector.component.html',
  styleUrls: ['./data-survey-field-selector.component.scss']
})
export class DataSurveyFieldSelectorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
